module.exports = __webpack_public_path__ + "static/img/cont56 (4).350b43e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont56 (4).jpg
// module id = wws6
// module chunks = 0